import { Railroad, Job } from 'src/shared/api';
import {
	OptionalJobFieldsToShow,
	OptionalJobFields,
} from './optional-fields.models';

export function railroadToOptionalJobFieldsToShow(
	railroad: Railroad
): OptionalJobFieldsToShow {
	return {
		showWorkOrderNumber: railroad.showWorkOrderNumber,
		showProjectNumber: railroad.showProjectNumber,
		showProjectManagerName: railroad.showProjectManagerName,
		showTermsAndConditions: railroad.showTermsAndConditions,
		showIsSupervisorJob: railroad.showIsSupervisorJob,
		showNetworkOrServiceOrder: railroad.showNetworkOrServiceOrder,
		showIsThirdPartyJob: railroad.showIsThirdPartyJob,
		showAgreementNumber: railroad.showAgreementNumber,
		showUpFolderNumber: railroad.showUpFolderNumber,
		showNsActivityNumber: railroad.showNsActivityNumber,
		showProtection: railroad.showProtection,
		showReferenceNumber: railroad.showReferenceNumber,
		showTrackID: railroad.showTrackID,
		showOrderNumber: railroad.showOrderNumber,
		showRequiresJobSetups: railroad.showRequiresJobSetups,
	};
}

export function jobToOptionalJobFields(job: Job): OptionalJobFields {
	return {
		workOrderNumber: job.workOrderNumber,
		projectNumber: job.projectNumber,
		projectManagerName: job.projectManagerName,
		termsAndConditions: job.termsAndConditions,
		isSupervisorJob: job.isSupervisorJob,
		networkOrServiceOrder: job.networkOrServiceOrder,
		isThirdPartyJob: job.isThirdPartyJob,
		agreementNumber: job.agreementNumber,
		upFolderNumber: job.upFolderNumber,
		nsActivityNumber: job.nsActivityNumber,
		protection: job.protection,
		referenceNumber: job.referenceNumber,
		requiresJobSetups: job.requiresJobSetups,
	};
}
